import React from "react";
import styles from "./LeftTabContent.module.scss";
import { useTranslation } from "react-i18next";

interface ContentItem {
  id: string;
  labelKey: string;
}

const CONTENT_ITEMS: ContentItem[] = [
  { id: "section-1", labelKey: "agrContentOne" },
  { id: "section-2", labelKey: "agrContentTwo" },
  { id: "section-3", labelKey: "agrContentThree" },
  { id: "section-4", labelKey: "agrContentFour" },
  { id: "section-5", labelKey: "agrContentFive" },
];

const SCROLL_OFFSET = 50;

const LeftTabContent = () => {
  const { t } = useTranslation();

  const scrollToSection = (id: string) => (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) {
      const top = el.getBoundingClientRect().top + window.pageYOffset - SCROLL_OFFSET;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  return (
    <div className={styles.sectionWrapper}>
      <div className={styles.tabContentWrapper}>
        <h2 className={styles.tabTitle}>{t("agreement")}</h2>
        <div className={styles.listWrapper}>
          <h3 className={styles.listTitle}>{t("agrContentTitle")}</h3>
          <ol className={styles.list}>
            {CONTENT_ITEMS.map((item) => (
              <li key={item.id}>
                <a href={`#${item.id}`} onClick={scrollToSection(item.id)}>
                  {t(item.labelKey)}
                </a>
              </li>
            ))}
          </ol>
        </div>

        <div className={styles.sectionWrapper}>
          <div id="section-1" className={styles.subtitle}>{t("agr1title")}</div>
          <div className={styles.text}>{t("1.1")}</div>
          <div className={styles.text}>{t("1.2")}</div>
          <div className={styles.text}>{t("1.3")}</div>
          <div className={styles.text}>{t("1.4")}</div>
          <div className={styles.text}>{t("1.5")}</div>
          <div className={styles.text}>{t("1.6")}</div>
          <div className={styles.text}>{t("1.7")}</div>
          <div className={styles.text}>{t("1.8")}</div>
          <div id="section-2" className={styles.subtitle}>{t("agr2title")}</div>
          <div className={styles.text}>{t("2.1")}</div>
          <div className={styles.text}>{t("2.2")}</div>
          <div className={styles.text}>{t("2.3")}</div>
          <div className={styles.text}>{t("2.4")}</div>
          <div className={styles.text}>{t("2.5")}</div>
          <div className={styles.text}>{t("2.6")}</div>
          <div className={styles.text}>{t("2.7")}</div>
          <div className={styles.text}>{t("2.8")}</div>
          <div className={styles.text}>{t("2.9")}</div>
          <div className={styles.text}>{t("2.10")}</div>
          <div className={styles.text}>{t("2.11")}</div>
          <div className={styles.text}>{t("2.12")}</div>
          <div className={styles.text}>{t("2.13")}</div>
          <div id="section-3" className={styles.subtitle}>{t("agr3title")}</div>
          <div className={styles.text}>{t("3.1")}</div>
          <div className={styles.text}>{t("3.2")}</div>
          <div className={styles.text}>{t("3.3")}</div>
          <div className={styles.text}>{t("3.4")}</div>
          <div className={styles.text}>{t("3.5")}</div>
          <div className={styles.text}>{t("3.6")}</div>
          <div className={styles.text}>{t("3.7")}</div>
          <div className={styles.text}>{t("3.8")}</div>
          <div className={styles.text}>{t("3.9")}</div>
          <div className={styles.text}>{t("3.10")}</div>
          <div className={styles.text}>{t("3.11")}</div>
          <div className={styles.text}>{t("3.12")}</div>
          <div className={styles.text}>{t("3.13")}</div>
          <div id="section-4" className={styles.subtitle}>{t("agr4title")}</div>
          <div className={styles.text}>{t("4.1")}</div>
          <div className={styles.text}>{t("4.2")}</div>
          <div className={styles.text}>{t("4.3")}</div>
          <div className={styles.text}>{t("4.4")}</div>
          <div className={styles.text}>{t("4.5")}</div>
          <div className={styles.text}>{t("4.6")}</div>
          <div className={styles.text}>{t("4.7")}</div>
          <div className={styles.text}>{t("4.8")}</div>
          <div className={styles.text}>{t("4.9")}</div>
          <div className={styles.text}>{t("4.10")}</div>
          <div className={styles.text}>{t("4.11")}</div>
          <div className={styles.text}>{t("4.12")}</div>
          <div className={styles.text}>{t("4.13")}</div>
          <div className={styles.text}>{t("4.14")}</div>
          <div className={styles.text}>{t("4.15")}</div>
          <div className={styles.text}>{t("4.16")}</div>
          <div className={styles.text}>{t("4.17")}</div>
          <div className={styles.text}>{t("4.18")}</div>
          <div className={styles.text}>{t("4.19")}</div>
          <div id="section-5" className={styles.subtitle}>{t("agr5title")}</div>
          <div className={styles.text}>{t("5.1")}</div>
          <div className={styles.text}>{t("5.2")}</div>
          <div className={styles.text}>{t("5.3")}</div>
          <div className={styles.text}>{t("5.4")}</div>
          <div className={styles.text}>{t("5.5")}</div>
          <div className={styles.text}>{t("5.6")}</div>
        </div>

      </div>
    </div>
  );
};

export default LeftTabContent;
